<template>
  <div class="c-select-wrapper">
    <label v-if="label" class="c-select-label" :for="uniqueId">
      {{ label }}
    </label>
    <o-icon :icon="icon" v-if="icon" />
    <div class="c-select-inner">
      <select
        :id="uniqueId"
        class="c-select"
        :readonly="readonly"
        v-model="value"
        @input="$emit('input')"
      >
        <option value="" v-if="placeholder" disabled>{{ placeholder }}</option>
        <slot :value="value" />
      </select>
    </div>
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OSelectInput',
  props: {
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    initial: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      uniqueId: '',
      value: ''
    }
  },
  methods: {
    generateUniqueId() {
      return (
        '_' +
        Math.random()
          .toString(36)
          .substr(2, 9)
      )
    }
  },
  created() {
    this.uniqueId = this.generateUniqueId()
    this.value = this.initial
  }
}
</script>

<style lang="scss">
.c-select-wrapper {
  align-items: center;
  display: flex;
  flex-wrap: wrap;

  .c-icon {
    color: $primary-color;
    color: var(--primary-color);
    flex: none;
    margin-right: 1.2rem;
  }
}

.c-select-inner {
  flex: 1 1 0;
}

.c-select {
  appearance: none;
  background: url('/icons/caret-down.svg') no-repeat right center;
  border: 0;
  color: inherit;
  display: block;
  font: inherit;
  width: 100%;
  outline: 0;
  padding-right: 1.6rem;
}

.c-select-label {
  color: $blue-kbc-cement;
  flex: none;
  font-size: 1.3rem;
  margin-bottom: 0.8rem;
  width: 100%;
}
</style>
